import { IconSvg } from '@prism/icon'
import { useContext } from 'react'
import { Spinner } from 'react-bootstrap'
import { StyledWatchListLink } from './WatchlistLink.styled'
import { VehicleContext } from 'modules/DealerVehicleManagement/VehicleContext'
import { useDtmAnalytics } from 'hooks/useDtmAnalytics'

export const WatchlistLink = () => {
  const { userInteraction } = useDtmAnalytics()
  const {
    vehicleData: {
      vehicle: { WatchListID }
    },
    vehicleWatchListState: { saveWatchList, isSaving }
  } = useContext(VehicleContext)

  const isWatched = WatchListID > 0

  const handleClick = () => {
    if (isWatched) {
      userInteraction('watch list: remove from watchlist')
    }
    saveWatchList()
  }

  return (
    <StyledWatchListLink>
      {isSaving ? (
        <Spinner animation="border" role="status" />
      ) : (
        <div onClick={handleClick}>
          {!WatchListID || WatchListID <= 0 ? (
            <span>
              <IconSvg glyph="eye" color="primary" />
              Watch
            </span>
          ) : (
            <span>
              <IconSvg glyph="eye-blocked" color="primary" />
              Unwatch
            </span>
          )}
        </div>
      )}
    </StyledWatchListLink>
  )
}
